function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "var(--primary-color, #000)",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1
    },
    d: "m 29.295366,4 c -6.828806,0 -12.364649,5.5359 -12.364649,12.3647 0,5.0789 3.039918,9.4571 7.41879,11.36 l 0,21.9087 5.139057,4.5594 4.752661,-4.5594 0,-5.1004 -2.472929,-2.2025 2.472929,-3.0525 -2.472929,-3.1298 2.472929,-2.1253 0,-2.8206 0,-3.4776 c 4.378872,-1.9029 7.41879,-6.2811 7.41879,-11.36 0,-6.8288 -5.535842,-12.3647 -12.364649,-12.3647 z m 0,5.3324 c 1.365762,0 2.47293,1.1071 2.47293,2.4728 0,1.3658 -1.107168,2.473 -2.47293,2.473 -1.365761,0 -2.472929,-1.1072 -2.472929,-2.473 0,-1.3657 1.107168,-2.4728 2.472929,-2.4728 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "var(--primary-color, #000)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 26.822437,30 0,21.5145"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Key.196ef45f.svg";
export { ForwardRef as ReactComponent };